export default __webpack_public_path__ + "static/media/coin.01a3de0c.svg";